import Loadable from "app/components/Loadable";
import { PERMISSIONS } from "app/utils/permissions";
import { lazy } from "react";

const FieldVisitKpiReport = Loadable(
  lazy(() => import("./FieldVisitKpiReport"))
);

const fieldVisitKpiRoutes = [
  {
    path: "/FieldVisitKpi/FieldVisitKpiReport",
    element: <FieldVisitKpiReport />,
    permission: PERMISSIONS.FieldVisitKpi.Menu,
  },
];
export default fieldVisitKpiRoutes;
